module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"You have been signed out","subtitle":"In order to use this application, you need to be signed in. Press the button below to sign in again."},"da":{"title":"Du er blevet logget ud!","subtitle":"For at kunne bruge brugerstyring.dk, skal du være logget ind. Klik på nedenstående knap, for at logge ind igen."}}')
  delete Component.options._Ctor
}
